import PERMISSIONS_LIST from '../../../../submodules/web-shared/modules/Permissions/permissions-list';

export const INSERT_POSITIONS = {
  BEFORE: 'before',
  AFTER: 'after'
};

export const enum KPI_NAME {
  ACTIVE_SHIPMENTS_IN_RED_ZONE = 'activeShipmentsInRedzone',
  ACTIVE_SHIPMENTS = 'activeShipments',
  VIOLATIONS = 'violations',
  ON_TIME_PERFORMANCE = 'onTimePerformance',
  AT_RISK_ETA_STATUS = 'atRiskEtaStatus',
  SHIPMENTS_BY_STATUS = 'shipmentsByStatus',
  DAILY_SHIPMENTS_STATUS = 'dailyShipmentsStatus',
  COMPLETING_TODAY = 'completingToday',
  ETA_AT_RISK_MAP = 'etaAtRiskMap',
  NON_COMPLIANCE = 'nonCompliance',
  NO_ETA_STATUS = 'noEtaStatus',
  LOST_SHIPMENTS = 'lostShipments',
  EARLY_ETA_STATUS = 'earlyEtaStatus',
  ON_TIME_ETA_STATUS = 'ontimeEtaStatus',
  LATE_ETA_STATUS = 'lateEtaStatus',
  MAP_INCIDENTS = 'mapIncidents',
  INBOUND = 'inbounds',
  OUTBOUNDS = 'outbounds',
  USER_PERFORMANCE = 'userPerformance',
  RISK_EVENTS_PERFORMANCE = 'riskEventsPerformance',
  RECOVERED_INCIDENTS = 'recoveredIncidents',
  SHIPMENT_MODE = 'shipmentMode',
  CARRIER_COMPLIANCE_BY_RISK = 'carrierComplianceByRisk',
  HIGH_RISK_BY_EVENT_TYPE = 'highRiskByEventType',
  CO2_EMISSIONS = 'co2Emissions',
  SHIPMENT_TEMPERATURE_ALERTS = 'shipmentTemperatureAlerts',
  TIME_SPENT_IN_QUALITY_EXCURSION = 'timeSpentInQualityExcursion',
  QUALITY_EXCURSION_INCIDENTS = 'qualityExcursionIncidents',
  QUALITY_SHIPMENT_RISK_STATUS = 'qualityRiskStatus',
  QUALITY_REGULATORY_HEAT_MAP = 'qualityRegulatoryHeatMap',
  QUALITY_RISK_SCORE = 'qualityRiskScore',
  QUALITY_EXCURSION_BY_TIME_PERIOD = 'qualityExcursionByTimePeriod',
}

export const permissionByKPIName: { [key in KPI_NAME]: PERMISSIONS_LIST } = {
  [KPI_NAME.ACTIVE_SHIPMENTS]: PERMISSIONS_LIST.active_shipments_dashboard_widget,
  [KPI_NAME.AT_RISK_ETA_STATUS]: PERMISSIONS_LIST.at_risk_eta_status_dashboard_widget,
  [KPI_NAME.USER_PERFORMANCE]: PERMISSIONS_LIST.user_performance_dashboard_widget,
  [KPI_NAME.COMPLETING_TODAY]: PERMISSIONS_LIST.completing_today_dashboard_widget,
  [KPI_NAME.DAILY_SHIPMENTS_STATUS]: PERMISSIONS_LIST.daily_shipments_status_dashboard_widget,
  [KPI_NAME.EARLY_ETA_STATUS]: PERMISSIONS_LIST.early_eta_status_dashboard_widget,
  [KPI_NAME.LATE_ETA_STATUS]: PERMISSIONS_LIST.late_eta_status_dashboard_widget,
  [KPI_NAME.ON_TIME_ETA_STATUS]: PERMISSIONS_LIST.ontime_eta_status_dashboard_widget,
  [KPI_NAME.NO_ETA_STATUS]: PERMISSIONS_LIST.no_eta_status_dashboard_widget,
  [KPI_NAME.ETA_AT_RISK_MAP]: PERMISSIONS_LIST.eta_at_risk_map_dashboard_widget,
  [KPI_NAME.SHIPMENT_MODE]: PERMISSIONS_LIST.shipment_mode_dashboard_widget,
  [KPI_NAME.ON_TIME_PERFORMANCE]: PERMISSIONS_LIST.on_time_performance_dashboard_widget,
  [KPI_NAME.SHIPMENTS_BY_STATUS]: PERMISSIONS_LIST.shipments_by_status_dashboard_widget,
  [KPI_NAME.ACTIVE_SHIPMENTS_IN_RED_ZONE]: PERMISSIONS_LIST.active_shipments_in_redzone_dashboard_widget,
  [KPI_NAME.CARRIER_COMPLIANCE_BY_RISK]: PERMISSIONS_LIST.carrier_compliance_by_risk_dashboard_widget,
  [KPI_NAME.HIGH_RISK_BY_EVENT_TYPE]: PERMISSIONS_LIST.high_risk_by_event_type_dashboard_widget,
  [KPI_NAME.INBOUND]: PERMISSIONS_LIST.inbounds_dashboard_widget,
  [KPI_NAME.LOST_SHIPMENTS]: PERMISSIONS_LIST.lost_shipments_dashboard_widget,
  [KPI_NAME.NON_COMPLIANCE]: PERMISSIONS_LIST.non_compliance_dashboard_widget,
  [KPI_NAME.OUTBOUNDS]: PERMISSIONS_LIST.outbounds_dashboard_widget,
  [KPI_NAME.RECOVERED_INCIDENTS]: PERMISSIONS_LIST.recovered_incidents_dashboard_widget,
  [KPI_NAME.MAP_INCIDENTS]: PERMISSIONS_LIST.map_incidents_dashboard_widget,
  [KPI_NAME.VIOLATIONS]: PERMISSIONS_LIST.violations_dashboard_widget,
  [KPI_NAME.CO2_EMISSIONS]: PERMISSIONS_LIST.co2e_dashboard_widget,
  [KPI_NAME.RISK_EVENTS_PERFORMANCE]: PERMISSIONS_LIST.risk_events_performance_dashboard_widget,
  [KPI_NAME.SHIPMENT_TEMPERATURE_ALERTS]: PERMISSIONS_LIST.shipment_temperature_alerts_dashboard_widget,
  [KPI_NAME.TIME_SPENT_IN_QUALITY_EXCURSION]: PERMISSIONS_LIST.time_spent_in_quality_excursion_dashboard_widget,
  [KPI_NAME.QUALITY_EXCURSION_INCIDENTS]: PERMISSIONS_LIST.quality_excursion_incidents_response_time_dashboard_widget,
  [KPI_NAME.QUALITY_SHIPMENT_RISK_STATUS]: PERMISSIONS_LIST.quality_risk_status_dashboard_widget,
  [KPI_NAME.QUALITY_REGULATORY_HEAT_MAP]: PERMISSIONS_LIST.quality_regulatory_heat_map_dashboard_widget,
  [KPI_NAME.QUALITY_RISK_SCORE]: PERMISSIONS_LIST.quality_risk_score_dashboard_widget,
  [KPI_NAME.QUALITY_EXCURSION_BY_TIME_PERIOD]: PERMISSIONS_LIST.quality_excursion_by_time_period_dashboard_widget,
};

export const DEFAULT_KPIS = [
  { name: KPI_NAME.ON_TIME_ETA_STATUS },
  { name: KPI_NAME.EARLY_ETA_STATUS },
  { name: KPI_NAME.AT_RISK_ETA_STATUS },
  { name: KPI_NAME.LATE_ETA_STATUS },
  { name: KPI_NAME.ETA_AT_RISK_MAP },
  { name: KPI_NAME.ACTIVE_SHIPMENTS },
  { name: KPI_NAME.COMPLETING_TODAY },
  { name: KPI_NAME.ON_TIME_PERFORMANCE },
  { name: KPI_NAME.SHIPMENTS_BY_STATUS },
  { name: KPI_NAME.DAILY_SHIPMENTS_STATUS },
  { name: KPI_NAME.USER_PERFORMANCE },
  { name: KPI_NAME.RISK_EVENTS_PERFORMANCE },
  { name: KPI_NAME.ACTIVE_SHIPMENTS_IN_RED_ZONE },
  { name: KPI_NAME.NON_COMPLIANCE },
  { name: KPI_NAME.RECOVERED_INCIDENTS },
  { name: KPI_NAME.LOST_SHIPMENTS },
  { name: KPI_NAME.MAP_INCIDENTS },
  { name: KPI_NAME.VIOLATIONS },
  { name: KPI_NAME.NO_ETA_STATUS },
  { name: KPI_NAME.TIME_SPENT_IN_QUALITY_EXCURSION }
];

